"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
const faqs = [{
  question: "How do you determine the price for junk removal?",
  answer: "Our pricing is strictly based on the volume of space your items occupy in our truck. We provide transparent, upfront quotes on-site with absolutely no hidden fees or surprise surcharges—just honest local pricing.",
  category: "Pricing"
}, {
  question: "What areas of Ottawa do you serve?",
  answer: "We proudly serve the entire Ottawa region, including Kanata, Orleans, Nepean, Barrhaven, and Stittsville. We emphasize same-day service availability to ensure your junk is cleared quickly and efficiently.",
  category: "Service"
}, {
  question: "Is JUNKR eco-friendly?",
  answer: "Absolutely. We prioritize responsible recycling and donation practices. We sort every load to ensure usable items reach local charities and materials like metal or electronics are processed by specialized recycling partners.",
  category: "Eco-Friendly"
}, {
  question: "Do you offer same-day service in Ottawa?",
  answer: "Yes! We offer reliable same-day service across all listed Ottawa neighborhoods, including Kanata and Orleans. Our team is optimized for fast response times to clear your space the moment you need it.",
  category: "Service"
}, {
  question: "What items are you unable to take?",
  answer: "While we take almost everything from furniture to appliances, we cannot haul hazardous materials such as chemicals, gasoline, oil, or asbestos due to safety and environmental regulations.",
  category: "Safety"
}, {
  question: "Where does my junk go after you pick it up?",
  answer: "We follow a strict eco-friendly disposal process. We sort through every load to donate usable furniture to local Ottawa charities and recycle metals and electronics to minimize landfill waste.",
  category: "Eco-Friendly"
}, {
  question: "Are you fully insured for residential work?",
  answer: "Yes, we are fully insured and WSIB-compliant. This reinforces our commitment to trust and safety, ensuring your home and property are completely protected during the entire removal process.",
  category: "Trust"
}, {
  question: "Do you serve my Ottawa area?",
  answer: "We cover all local neighborhoods including Kanata, Orleans, Barrhaven, Nepean, and downtown Ottawa, often with same-day service availability.",
  category: "Service"
}, {
  question: "How fast can you remove junk?",
  answer: "We offer rapid response times with same-day and next-day removal options to get your space cleared as quickly as possible.",
  category: "Service"
}, {
  question: "Are you fully insured?",
  answer: "Yes, JUNKR is fully insured and WSIB compliant, providing complete peace of mind for every residential and commercial project.",
  category: "Trust"
}, {
  question: "What happens to my junk?",
  answer: "We focus on landfill reduction by donating usable items to local charities and ensuring all recyclable materials are processed correctly.",
  category: "Eco-Friendly"
}, {
  question: "Is pricing transparent?",
  answer: "Yes, we provide clear, upfront quotes before any work begins, ensuring there are no hidden fees or unexpected costs.",
  category: "Pricing"
}, {
  question: "How much does junk removal cost?",
  answer: "Pricing is based on the volume of junk removed. We offer free on-site estimates to provide you with an accurate, no-obligation price.",
  category: "Pricing"
}];
export default function CommonTechQuestions() {
  return <section data-section-id="253061" id="common-questions" className="bg-background text-foreground py-24 px-4 md:px-8 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-lg pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold mb-6 tracking-tighter text-foreground">
            Common Questions About Junk Removal in Ottawa
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed font-default">
            Everything you need to know about our Ottawa junk removal services, pricing, and eco-friendly disposal.
          </p>
        </div>

        <div className="border border-border/60 rounded-2xl bg-card/50 backdrop-blur-md p-6 md:p-10 relative overflow-hidden shadow-2xl">
          <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent pointer-events-none" />

          <Accordion type="single" collapsible className="w-full relative z-10">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-primary/20 last:border-0">
                <AccordionTrigger className="hover:no-underline py-6 group">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-4 text-left w-full pr-4">
                    <span className="font-default font-bold text-lg md:text-xl text-foreground group-hover:text-secondary transition-colors duration-300">
                      {faq.question}
                    </span>
                    <Badge variant="outline" className="w-fit sm:ml-auto border-secondary/30 text-secondary bg-secondary/5 backdrop-blur-sm font-mono text-xs uppercase tracking-widest">
                      {faq.category}
                    </Badge>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-foreground/70 text-base md:text-lg leading-loose pb-8 pr-8 sm:pr-24 font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground font-default">
            Still have questions? <span className="text-secondary font-bold">Call us at (613) 555-0123 for a free estimate. We respond within 2 hours.</span>
          </p>
        </div>
      </div>
    </section>;
}